const ImageInput = ({ id, children, handleChange }) => (
  <label className={`${id}-image-file-input-label`} htmlFor={`${id}-image-file-input`}>
    <input accept='image/*' onChange={handleChange} id={`${id}-image-file-input`} style={{ display: 'none' }} type='file' />
    { children }
  </label>
);

export default ImageInput;
